// Reads given blob and encodes it with base64. Returns a Promise.
const encodeBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => {
      reject(new DOMException('Problem with reading preview image'));
    };
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });

// Scales given SVG (XMLDocument).
function scaleSvg(svg, pageWidth) {
    const viewbox = svg.attributes.viewBox.value.split(' ');
    let width = parseInt(viewbox[2]);
    let height = parseInt(viewbox[3]);
    let min = 600;
    let max = 800;
  
    if (min > pageWidth) {
      min = pageWidth - 40;
      max = min;
    }
  
    if (width < min) {
      const percent = width / min;
      width = min;
      height += height - height * percent;
    } else if (width > max) {
      const percent = max / width;
      width = max;
      height = height * percent;
    }
  
    svg.setAttribute('width', width);
    svg.setAttribute('height', height);
  }

function svg_to_img(svg) {
  let img_blob = new Blob([svg], {type: "image/svg+xml"});
  return URL.createObjectURL(img_blob);
}

export { encodeBase64, scaleSvg, svg_to_img };